import React, { Component, PropTypes } from 'react';
import RichTextEditor from 'react-rte';
// import { Icon } from 'components/ui';
import FormError from './FormError';
import { ControlLabel } from 'react-bootstrap';

const INLINE_STYLE_BUTTONS = [
  { label: 'Bold', style: 'BOLD' },
  { label: 'Italic', style: 'ITALIC' },
  { label: 'Strikethrough', style: 'STRIKETHROUGH' },
  { label: 'Underline', style: 'UNDERLINE' }
];

const toolbarConfig = {
  display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS'],
  INLINE_STYLE_BUTTONS
};

export default class RichTextInput extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    const { input } = props;
    this.state = {
      richValue: input.value
        ? RichTextEditor.createValueFromString(input.value, 'html')
        : RichTextEditor.createEmptyValue(),
      htmlValue: input.value
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.input.value !== this.state.htmlValue) {
      this.setState({
        richValue: RichTextEditor.createValueFromString(
          nextProps.input.value,
          'html'
        ),
        htmlValue: nextProps.input.value
      });
    }
  }

  handleChange(richValue) {
    this.setState({ richValue, htmlValue: richValue.toString('html') });
    this.props.input.onChange(this.state.htmlValue);
  }

  render() {
    const { label, id, placeholder, input, meta, labelStyle } = this.props;
    const hasError = meta.touched && meta.error;

    return (
      <div>
        {label && <ControlLabel style={ labelStyle || {}}>{label}</ControlLabel>}
        {hasError &&
          <div className="has-error">
            <div className="error-container">
              <small className="error" />
            </div>
          </div>}
        <RichTextEditor
          value={this.state.richValue}
          placeholder={placeholder}
          onChange={this.handleChange}
          toolbarConfig={toolbarConfig}
          name={id}
        />

      </div>
    );
  }
}

RichTextInput.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string,
  placeholder: PropTypes.string,
  field: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/components/forms/Wysiwyg.js